import { Button } from "@mui/material";
import type { ButtonProps, ButtonPropsVariantOverrides } from "@mui/material";
import type { OverridableStringUnion } from "@mui/types";
import { ThemeProvider } from "@emotion/react";
import { useSelector } from "react-redux";
import type { RootState } from "../../store";
import Theme from "../../utils/theme";
import { useMemo } from "react";

interface ICustomButtonProps extends ButtonProps {
    variant?: OverridableStringUnion<"text" | "outlined" | "contained", ButtonPropsVariantOverrides>;
    label: string;
    type?: "button" | "submit" | "reset";
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    sx: object;
}

const CustomButton: React.FC<ICustomButtonProps> = ({ variant, label, type, onClick, disabled, sx }) => {
    const themeState = useSelector((state: RootState) => state.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);

    const combinedStyles = {
        borderRadius: "20px",
        boxShadow: 3,
        minWidth: 0,
        backgroundColor: theme.palette.primary.light,
        ...sx,
    };

    return (
        <ThemeProvider theme={theme}>
            <Button disabled={disabled} variant={variant} color="primary" type={type} onClick={onClick} sx={combinedStyles}>
                {label}
            </Button>
        </ThemeProvider>
    );
};

export default CustomButton;
